/*
 * @Descripttion: 
 * @version: 
 * @Author: leon
 * @email: leon0023@zoho.com.cn
 * @Date: 2022-09-20 14:55:19
 * @LastEditors: K
 * @LastEditTime: 2022-09-22 17:03:14
 */

import { Form, Row, Col, TimePicker, Input, Button } from 'antd';
import form from 'antd/lib/form';
import moment from 'moment';
import React, { ReactElement, useEffect } from 'react';
import { Checks } from '../../../../models/setting';
import styles from '../TenantSetting.module.css'
interface TransferSettlementProps {
  formObj: any
  formChange: () => void
  onSave: (obj: any) => void
}

export const TransferSettlement = ({ formObj, formChange, onSave }: TransferSettlementProps): ReactElement => {
  const [form] = Form.useForm()

  useEffect(() => {
    if (!formObj) return
    const value = formObj[Checks.Zdrjsj]
    form.setFieldsValue({
      ...formObj,
      [Checks.Zdrjsj]:
        value === '' || value === undefined || value === 'Invadlid date'
          ? undefined
          : moment(value, 'HH:mm'),
    })
  }, [formObj])
  return (
    <div style={{ padding: '0 10px' }}>
      <Form
        form={form}
        autoComplete='off'
        onFinish={(values) => {
          onSave(values)
        }}
        onValuesChange={() => formChange()}
      >
        <Row>
          <Col style={{ marginLeft: '50px', marginRight: '60px' }}>
            <Form.Item label='指定日结时间' name={Checks.Zdrjsj}>
              <TimePicker format='HH:mm' style={{ width: '200px' }} />
            </Form.Item>
          </Col>
          <Col>
            <Form.Item label='结转日期设定' name={Checks.Jzrqsd}>
              <Input style={{ width: '200px' }} />
            </Form.Item>
          </Col>
        </Row>
      </Form>
      <div className={styles.btnWrap}>
        <Button onClick={form.submit} type='primary'>
          确认
        </Button>
      </div>
    </div>
  );
}